import {Vue, Component} from 'vue-property-decorator';
import store from "@/store";

@Component<Footer>({
    components: ({})
})

export default class Footer extends Vue {

    private get affiliateId(): number{
        if(store.state.affiliateViewData){
            return store.state.affiliateViewData.user_id;
        }
        return 0;
    }

}